import * as React from 'react'
import { withRouter } from 'next/router'
import { TrackListItemComponent } from '@components/Track/TrackListItem'
import type { NewReleasesPropsType } from '../../models/Category'
import { getNewReleasesPropsAsync } from '../../models/Category'
import type { TrackPropsType } from '../../models/Track'
import DiscoverLayout from '@components/Discover/DiscoverLayout'
import { PageTitle } from '@components/shared/PageTitle'
import styled from 'styled-components'
import { config } from 'react-awesome-styled-grid'
import { colors } from '@components/shared/colors'
function NewReleases (props: NewReleasesPropsType): React.ReactNode {
  return (
    <DiscoverLayout title={`Listen to New Releases on Dipsea`} canonicalUrl={'https://www.dipseastories.com/chapters/new-releases'}>
        <PageTitle title={props.title}/>
        {props.tracks.map((track: TrackPropsType): React.ReactNode => (
          <SectionDivider key={track.id}>
            <TrackListItemComponent {...track} key={track.id}/>
          </SectionDivider>
        ))}
    </DiscoverLayout>
  )
}
export default withRouter(NewReleases as any) as any

type ContextType = {
  params: {
    slug: string
  }
}
export async function getStaticProps (
  _context: ContextType
): Promise<{ props: NewReleasesPropsType }> {
  const newReleases = await getNewReleasesPropsAsync()
  return { props: newReleases }
}

const SectionDivider = styled.div<any>`
  padding: 15px 0;
  border-bottom: 1px solid ${colors.white25};
  ${(props: any): any => config(props).media.md`
    padding: 30px 0;
  `}
`
